import { Routes } from '@angular/router';
import { authGuard, noAuthGuard, wordpressRedirectGuard } from './modules/client/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    // Called from WordPress when the user clicks "Cerrar sesión".
    // Clears the Cognito session on this domain and redirects back to returnUrl.
    path: 'logout',
    loadComponent: () => import('./modules/client/auth/pages/logout/logout.component').then(m => m.LogoutComponent)
  },
  {
    // OAuth popup handler — opened by the embedded iframe to bypass the restriction
    // that Google/Facebook place on OAuth flows inside iframes (HTTP 403).
    // No guard: this route must be reachable without a session or iframe context.
    path: 'oauth-popup',
    loadComponent: () => import('./modules/client/auth/pages/oauth-popup/oauth-popup.component').then(m => m.OAuthPopupComponent)
  },
  {
    path: 'panel',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/client/panel/layout/panel-layout/panel-layout.component').then(m => m.PanelLayoutComponent),
    children: [
      { path: 'profile', loadComponent: () => import('./modules/client/panel/pages/profile/profile.component').then(m => m.ProfileComponent) },
      { path: 'subscription', loadComponent: () => import('./modules/client/panel/pages/subscription/subscription.component').then(m => m.SubscriptionComponent) },
      { path: 'interests', loadComponent: () => import('./modules/client/panel/pages/interests/interests.component').then(m => m.InterestsComponent) },
      { path: 'history', loadComponent: () => import('./modules/client/panel/pages/history/history.component').then(m => m.HistoryComponent) },
      { path: 'notifications', loadComponent: () => import('./modules/client/panel/pages/notifications/notifications.component').then(m => m.NotificationsComponent) },
      { path: '', redirectTo: 'subscription', pathMatch: 'full' }
    ]
  },
  {
    path: 'planes',
    // Accesible tanto para usuarios autenticados como no autenticados.
    // Se renderiza dentro de un iframe desde WordPress (embed=1).
    loadComponent: () => import('./modules/client/pages/planes/planes.component').then(m => m.PlanesComponent)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.routes').then(m => m.adminRoutes),
  },
  // Cualquier ruta no reconocida redirige al WordPress principal.
  // Esto incluye '/', '/home', '/client' y cualquier URL desconocida.
  {
    path: '**',
    canActivate: [wordpressRedirectGuard],
    loadComponent: () => import('./modules/client/auth/pages/login/login.component').then(m => m.LoginComponent)
  }
];


